import { render, staticRenderFns } from "./ZonesOverview.vue?vue&type=template&id=1365e037&scoped=true&"
import script from "./ZonesOverview.vue?vue&type=script&lang=ts&"
export * from "./ZonesOverview.vue?vue&type=script&lang=ts&"
import style0 from "./ZonesOverview.vue?vue&type=style&index=0&id=1365e037&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1365e037",
  null
  
)

export default component.exports